<template>
    <div class="content">
      <h1>Cookie Policy</h1>
      <p><strong>Last updated:</strong> 2025-05-11</p>

      <p>
        At TANM (Takeaway Near Me), we believe in transparency — especially when it comes to your data. Like most websites, we use cookies to improve your experience and understand how people use our platform.
      </p>

      <p>This page explains what cookies we use and how you can control them.</p>

      <h2>What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device when you browse websites. They help things work properly — like keeping you logged in or remembering what’s in your cart.
      </p>

      <h2>Why We Use Cookies</h2>
      <ul>
        <li>Keep the site secure and functioning correctly.</li>
        <li>Understand how people interact with TANM so we can improve the experience.</li>
        <li>Power services like <strong>Stripe</strong> for payments and <strong>Microsoft Clarity</strong> for user experience analytics.</li>
      </ul>

      <h2>What Cookies Are In Use?</h2>

      <h3>Essential Cookies</h3>
      <p>
        These are required for things like logging in, navigating the site, and making payments. Without them, TANM wouldn’t work properly.
      </p>

      <h3>Analytics & Insights (Optional)</h3>
      <p>
        We use <strong>Microsoft Clarity</strong> to see how visitors interact with the platform — clicks, scrolling, and general usage patterns. This helps us improve performance and design.
      </p>
      <p>
        Clarity may collect anonymized data like browser type, screen resolution, and session duration. No personal data like names or payment info is collected.
      </p>
      <p>
        Learn more at <a href="https://clarity.microsoft.com" target="_blank" rel="noopener">clarity.microsoft.com</a>.
      </p>

      <h3>Stripe Cookies</h3>
      <p>
        When making payments, Stripe may set cookies to handle fraud detection, session management, and secure payment flows. These are essential for payment processing.
      </p>

      <h2>How To Manage Cookies</h2>
      <p>
        You can change your browser settings to block or delete cookies anytime. Just know that turning off essential cookies may break parts of the site (like logging in or checking out).
      </p>
      <p>
        To learn more, visit <a href="https://www.aboutcookies.org" target="_blank" rel="noopener">aboutcookies.org</a>.
      </p>

      <h2>Future Changes</h2>
      <p>
        As TANM grows, we may add more tools or change how cookies are used. This page will be updated when that happens.
      </p>

      <h2>Contact</h2>
      <p>
        Got questions about cookies or privacy? Reach out at: <strong>[insert contact email]</strong>
      </p>
    </div>
</template>

